/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Style_Toggle_HideInputs */



/**
* | output |
* | --- |
* | "Hide Subtitle Styling" |
*
* @param {Video_Export_Style_Toggle_HideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_style_toggle_hide = /** @type {((inputs?: Video_Export_Style_Toggle_HideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Style_Toggle_HideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Masquer le style des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitelformatierung ausblenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nascondi stile sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скрыть стиль субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ocultar el estilo de los subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("隐藏副标题样式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕スタイルを非表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक शैली को छुपाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ocultar estilo de legenda")
	return /** @type {LocalizedString} */ ("Hide Subtitle Styling")
});